import { render, staticRenderFns } from "./InterfaceTokensModal.vue?vue&type=template&id=0fda85ac&scoped=true&lang=html&"
import script from "./InterfaceTokensModal.vue?vue&type=script&lang=js&"
export * from "./InterfaceTokensModal.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceTokensModal.vue?vue&type=style&index=0&id=0fda85ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda85ac",
  null
  
)

export default component.exports